import { render, staticRenderFns } from "./NSPKLoyaltyRegisterFrameManager.vue?vue&type=template&id=24d25f12&"
import script from "./NSPKLoyaltyRegisterFrameManager.vue?vue&type=script&lang=ts&"
export * from "./NSPKLoyaltyRegisterFrameManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports